(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__pekaSmoothTotalV23) return;
    window.__pekaSmoothTotalV23 = true;

    const rootSelector = 'main[data-template="product"]';

    const updateTotal = () => {
      const root = document.querySelector(rootSelector);
      if (!root) return;

      const priceElement = root.querySelector('product-price[data-peka-smooth-total="true"]');
      const totalTarget = priceElement?.querySelector('[data-peka-total-price]');
      const form = root.querySelector('product-form-component form[action*="/cart/add"]');
      if (!priceElement || !totalTarget || !form) return;

      const variantInput = form.querySelector('input[name="id"]');
      const quantityInput = form.querySelector('input[name="quantity"]');
      if (!variantInput || !quantityInput) return;

      let prices;
      try {
        prices = JSON.parse(priceElement.dataset.pekaVariantPrices || '{}');
      } catch {
        return;
      }

      const rawVariantId = String(variantInput.value || '');
      const numericVariantId = rawVariantId.split('/').pop();
      const unitPrice = Number(prices[rawVariantId] ?? prices[numericVariantId]);
      const quantity = Math.max(1, Number(quantityInput.value) || 1);
      if (!Number.isFinite(unitPrice)) return;

      const currency = priceElement.dataset.pekaCurrency || 'EUR';
      const locale = priceElement.dataset.pekaLocale || document.documentElement.lang || 'fr-FR';
      const formatted = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency
      }).format((unitPrice * quantity) / 100);

      totalTarget.textContent = formatted;
    };

    let timer;
    const schedule = (delay = 0) => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => window.requestAnimationFrame(updateTotal), delay);
    };

    document.addEventListener('input', (event) => {
      const target = event.target;
      if (target instanceof HTMLInputElement && target.name === 'quantity') schedule();
    });

    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;
      if (target.matches('input[name="quantity"]') || target.closest('variant-picker')) schedule(40);
    });

    document.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      if (target.closest('quantity-selector-component button')) {
        schedule();
      }

      if (target.closest('variant-picker')) {
        schedule(60);
        window.setTimeout(updateTotal, 180);
      }
    });

    const start = () => {
      const root = document.querySelector(rootSelector);
      if (!root) return;

      updateTotal();

      const observer = new MutationObserver(() => schedule());
      observer.observe(root, {
        childList: true,
        subtree: true
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
